export const styles = {
	paper: {
		marginTop: 8,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center'
	},
	avatar: {
		margin: 1,
		backgroundColor: 'primary.main'
	},
	step: {
		textTransform: 'uppercase'
	},
	formControl: {
		minWidth: '100%'
	},
	form: {
		width: '100%', // Fix IE 11 issue.
		marginTop: 2
	},
	submit: {
		margin: '24px 0px 16px'
	},
	header: {
		position: 'static',
		paddingLeft: '26px',
		paddingTop: '6px',
		background: '#eaebec',
		height: 70
	},
	link: {
		textDecoration: 'none'
	}
};
